var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16602 12.0001V7.66675C5.16602 7.40153 5.06066 7.14718 4.87312 6.95964C4.68559 6.7721 4.43123 6.66675 4.16602 6.66675C3.9008 6.66675 3.64645 6.7721 3.45891 6.95964C3.27137 7.14718 3.16602 7.40153 3.16602 7.66675V10.6667C3.16602 11.0204 3.30649 11.3595 3.55654 11.6096C3.80659 11.8596 4.14573 12.0001 4.49935 12.0001H5.16602ZM5.16602 12.0001V9.33341H11.8327V12.0001M5.16602 12.0001H11.8327M11.8327 12.0001V7.66675C11.8327 7.40153 11.938 7.14718 12.1256 6.95964C12.3131 6.7721 12.5675 6.66675 12.8327 6.66675C13.0979 6.66675 13.3523 6.7721 13.5398 6.95964C13.7273 7.14718 13.8327 7.40153 13.8327 7.66675V10.6667C13.8327 11.0204 13.6922 11.3595 13.4422 11.6096C13.1921 11.8596 12.853 12.0001 12.4993 12.0001H11.8327ZM5.16602 14.6667H11.8327M10.166 14.6667H6.83268V12.0001H10.166V14.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8327 6.66671V5.33337C12.8327 3.44804 12.8327 2.50471 12.2467 1.91937C11.6613 1.33337 10.718 1.33337 8.83268 1.33337H8.16602C6.28068 1.33337 5.33735 1.33337 4.75202 1.91937C4.16602 2.50471 4.16602 3.44804 4.16602 5.33337V6.66671",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatTimeline);
export default __webpack_public_path__ + "static/media/seat-timeline.fe45d8e066fb21fae5343f7cb61cd7ba.svg";
export { ForwardRef as ReactComponent };